import { css } from 'styled-components';
import * as gridUtils from '../../theme/utils/grid/grid';
export const grid = _ref => {
  let {
    theme,
    $gutter,
    $wrap,
    $valign,
    $halign,
    $addCSS
  } = _ref;
  return css(["", " ", ""], gridUtils.grid(theme, {
    gutter: $gutter,
    wrap: $wrap,
    valign: $valign,
    halign: $halign
  }), $addCSS);
};
export const unit = _ref2 => {
  let {
    theme,
    $size,
    $gutter,
    $addCSS
  } = _ref2;
  return css(["", " ", ""], gridUtils.gridUnit(theme, {
    size: $size,
    gutter: $gutter
  }), $addCSS);
};
//# sourceMappingURL=Grid.style.js.map